import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Firebase configuration - publishable client-side keys
// Protected by Firebase Security Rules on the backend
const firebaseConfig = {
  apiKey: "AIzaSyAwVJduaek8n4WW4Go9zfWdrUKDJ3gRvKs",
  // Use default Firebase authDomain for popup auth to work reliably
  authDomain: "applywise-4d349.firebaseapp.com",
  projectId: "applywise-4d349",
  storageBucket: "applywise-4d349.firebasestorage.app",
  messagingSenderId: "907115125824",
  appId: "1:907115125824:web:689f6ac85c9597703cd3a5",
};

// Initialize Firebase - prevent duplicate initialization during HMR
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider with prompt to select account
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
